import { Flex } from "@chakra-ui/react";
import { FUNNEL_TYPES } from "../../funnel/utils/contants";
import { SignUpModalBody, SignUpModalFooter } from "./SignUpModal";
import { LoginModalBody, LoginModalFooter } from "./LoginModal";
import {
  SignUpWithEmailPasswordModalBody,
  SignUpWithEmailPasswordModalFooter,
} from "./SignUpWithEmailPasswordModal";
import { FunnelComponentProps, FunnelConfigTypes } from "../../funnel/types";
import { useState } from "react";

export interface AuthFunnelProps {
  activeType?: FUNNEL_TYPES;
  initialFunnelType?: FUNNEL_TYPES;
  funnelProps?: FunnelComponentProps;
  welcomeText?: string;
  waiting?: boolean;
  loadingText?: string;
  showEmailPasswordForm?: boolean;
  centerWelcomeText?: boolean;
  largeLoginCTA?: boolean;
  loginWelcomeText?: string;
}

export function AuthFunnelContent({
  activeType,
  initialFunnelType,
  funnelProps,
  welcomeText,
  waiting,
  loadingText,
  showEmailPasswordForm = false,
  centerWelcomeText = false,
  largeLoginCTA = false,
  loginWelcomeText,
}: AuthFunnelProps) {
  const [activeAuthType, setFunnelType] = useState<FUNNEL_TYPES>(
    initialFunnelType || FUNNEL_TYPES.signup,
  );

  if (!funnelProps) {
    funnelProps = {
      setFunnelType,
      updateFunnelConfig: (config: FunnelConfigTypes) => {
        if (config.type) {
          setFunnelType(config.type);
        }
      },
      onClose: () => {},
      onSuccess: () => {},
    };
  }

  const active = activeType || activeAuthType;

  return (
    <Flex width="100%" flexDirection="column" gap="24px">
      {active === FUNNEL_TYPES.signup && (
        <>
          <SignUpModalBody
            {...funnelProps}
            valueProps={[]}
            welcomeText={welcomeText}
            showEmailPasswordForm={showEmailPasswordForm}
            centerWelcomeText={centerWelcomeText}
            largeLoginCTA={largeLoginCTA}
            spinning={waiting}
            loadingText={loadingText}
          />
          <SignUpModalFooter {...funnelProps} largeLoginCTA={largeLoginCTA} />
        </>
      )}
      {active === FUNNEL_TYPES.login && (
        <>
          <LoginModalBody
            {...funnelProps}
            loading={waiting}
            loadingText={loadingText}
            welcomeText={loginWelcomeText}
          />
          <LoginModalFooter />
        </>
      )}
      {active === FUNNEL_TYPES.signupEmailPassword && (
        <>
          <SignUpWithEmailPasswordModalBody
            {...funnelProps}
            loading={waiting}
            loadingText={loadingText}
          />
          <SignUpWithEmailPasswordModalFooter {...funnelProps} />
        </>
      )}
    </Flex>
  );
}
